module.exports = __webpack_public_path__ + "static/media/logo.816ebf68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.png
// module id = 512
// module chunks = 3